import { render, staticRenderFns } from "./reklas.vue?vue&type=template&id=5cf2adb7&"
import script from "./reklas.vue?vue&type=script&lang=js&"
export * from "./reklas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports